// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3f2mF","title":"InfoRow_title__1S3zP"};